module.exports = __webpack_public_path__ + "img/PL10079.e4bfa53e.png";